import React from 'react'

export default () => {
  return (
    <div>
        <h2>Based on your responses, this dizziness is most likely being caused by a condition called  <strong className="text-decoration" data-tip="A condition characterized by the persistent feeling of rocking or swaying, worsened by anxiety or complex visual stimuli. occurring for more than 50% of the days in a 3-month period or longer.">Persistent Postural-Perceptual Dizziness (PPPD).</strong> </h2>
        <p>PPPD is one of the most common causes of dizziness, </p>
        <h5>Symptoms are typically worsened by:</h5>
        
        <ol>
           <li><i className="n-box">1</i> Stress or Anxiety</li>
          <li><i className="n-box">2</i> Head or body motion</li>
          <li><i className="n-box">3</i> Exposure to complex or motion-rich environments like crowds</li>
        </ol>
        
        <p>It is most often triggered by an event that causes acute dizziness, vertigo, or disruption of balance, such as a panic attack with dizziness, a mild TBI like whiplash or a concussion, or a vestibular migraine</p>
        <a id="PPPD" href="https://www.rehabmart.com/post/why-am-i-dizzy-top-5-causes-of-dizziness-what-to-do" target="_black">read more about this condition ></a>
    </div>
  )
}
